module.exports = __webpack_public_path__ + "static/media/kacey-musgraves-golden-hour-album-2018-billboard-embed@2x.dc7c6938.png";